import { useCallback, useEffect, useState } from 'react'
import { setTextLarge } from '@/ds'

const KEY = 'v2.textLarge'

/** Modo de texto grande (inventario D20): atributo en <html>, persistido por dispositivo. */
export function useTextLarge(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState<boolean>(() => {
    try {
      return localStorage.getItem(KEY) === '1'
    } catch {
      return false
    }
  })
  useEffect(() => {
    setTextLarge(on)
  }, [on])
  const update = useCallback((next: boolean) => {
    setOn(next)
    try {
      localStorage.setItem(KEY, next ? '1' : '0')
    } catch {
      /* sin almacenamiento */
    }
  }, [])
  return [on, update]
}
